/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeploymentExternalMCP = {
  /**
   * The ID of the deployment external MCP record.
   */
  id: string;
  /**
   * The display name for the external MCP server.
   */
  name: string;
  /**
   * The ID of the external MCP registry the server is from.
   */
  registryId?: string | undefined;
  /**
   * The canonical server name used to look up the server in the registry.
   */
  registryServerSpecifier: string;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  slug: string;
};

/** @internal */
export const DeploymentExternalMCP$inboundSchema: z.ZodMiniType<
  DeploymentExternalMCP,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    name: z.string(),
    registry_id: z.optional(z.string()),
    registry_server_specifier: z.string(),
    slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "registry_id": "registryId",
      "registry_server_specifier": "registryServerSpecifier",
    });
  }),
);

export function deploymentExternalMCPFromJSON(
  jsonString: string,
): SafeParseResult<DeploymentExternalMCP, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeploymentExternalMCP$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeploymentExternalMCP' from JSON`,
  );
}
